import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { ThemeProvider } from './providers/ThemeProvider';
import QueryProvider from './providers/QueryProvider';
import '@shared/styles/index.css';

// Injected by Vite at build time
declare const __BUILD_TIMESTAMP__: string;

// eslint-disable-next-line no-console
console.log(
  '%c Vaera %c Build: ' + (typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : 'Local'),
  'background: #3b82f6; color: white; padding: 2px 4px; border-radius: 2px 0 0 2px;',
  'background: #1e293b; color: white; padding: 2px 4px; border-radius: 0 2px 2px 0;'
);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const app = (
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <QueryProvider>
      <ThemeProvider>
        <App />
        <Toaster />
      </ThemeProvider>
    </QueryProvider>
  </BrowserRouter>
);

// Disable StrictMode to prevent double-mounting glitches with 3D scene
// StrictMode intentionally double-mounts components in dev to detect side effects,
// but this causes issues with Three.js scene initialization and CSS3D rendering
ReactDOM.createRoot(rootElement).render(app);

// Remove initial loader if user is NOT on landing page
// Landing page will handle its own loader management
setTimeout(() => {
  const initialLoader = document.getElementById('initial-loader');
  const isOnLandingPage = window.location.pathname === '/' || window.location.pathname === '';

  if (initialLoader && !isOnLandingPage) {
    initialLoader.style.opacity = '0';
    initialLoader.style.transition = 'opacity 0.3s ease-out';
    setTimeout(() => {
      initialLoader.remove();
    }, 300);
  }
}, 500); // Wait a bit longer to ensure routing is complete
